import { FC } from 'react'
import { LayoutHeader } from '@/components/domains/layouts'
import PolicyLocationService from '@/components/domains/policy/PolicyLocationService'

const PagePolicyLocationService: FC = () => {
  return (
    <>
      <LayoutHeader />
      <PolicyLocationService />
    </>
  )
}

export default PagePolicyLocationService
